import {
    BUSINESS_EVENTBRITE_CATEGORY,
    FILM_EVENTBRITE_CATEGORY,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SCIENCE_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { BrandState } from '../../types/index';

// "You've Got Plans" marketing campaign
import YGP_HEADER_CHI from '../../static/images/browse/YGP_citybrowseheader_CHI_791x488px@2x.webp';
import YGP_HEADER_DC from '../../static/images/browse/YGP_citybrowseheader_DC_791x488px@2x.webp';
import YGP_HEADER_GENERIC from '../../static/images/browse/YGP_citybrowseheader_Generic_791x488px@2x.webp';
import YGP_HEADER_LA from '../../static/images/browse/YGP_citybrowseheader_LA_791x488px@2x.webp';
import YGP_HEADER_LDN from '../../static/images/browse/YGP_citybrowseheader_LDN_791x488px@2x.webp';
import YGP_HEADER_NYC from '../../static/images/browse/YGP_citybrowseheader_NYC_791x488px@2x.webp';
import YGP_HEADER_SF from '../../static/images/browse/YGP_citybrowseheader_SF_791x488px@2x.webp';

import {
    ENGLISH_TLDs,
    TLD_AUSTRALIA,
    TLD_CANADA,
    TLD_IRELAND,
    TLD_NEW_ZEALAND,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
} from '../../constants/constants';

// List of buckets that should link to new browse page
export const BROWSE_PAGE_LINK_KEYS: string[] = [
    'performing_and_visual_arts_events',
    'science_and_technology_events',
    'business_and_professional_events',
    'food_and_drink_events',
    'music_events',
    'film_media_and_entertainment_events',
    'health_and_wellness_events',
];

export const BROWSE_BUCKET_CATEGORY_MAP: Record<string, string> = {
    performing_and_visual_arts_events: PERFORMING_EVENTBRITE_CATEGORY,
    science_and_technology_events: SCIENCE_EVENTBRITE_CATEGORY,
    business_and_professional_events: BUSINESS_EVENTBRITE_CATEGORY,
    food_and_drink_events: FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    music_events: MUSIC_EVENTBRITE_CATEGORY,
    film_media_and_entertainment_events: FILM_EVENTBRITE_CATEGORY,
    health_and_wellness_events: HEALTH_EVENTBRITE_CATEGORY,
};

export const BROWSE_HEADER_PLACE_OVERRIDES: {
    [placeId: string]: Partial<BrandState>;
} = {
    // New York
    '85977539': {
        headerImageUrl: YGP_HEADER_NYC,
    },
    // San Francisco
    '85922583': {
        headerImageUrl: YGP_HEADER_SF,
    },
    // Los Angeles
    '85923517': {
        headerImageUrl: YGP_HEADER_LA,
    },
    // Chicago
    '85940195': {
        headerImageUrl: YGP_HEADER_CHI,
    },
    // Washington DC
    '85931779': {
        headerImageUrl: YGP_HEADER_DC,
    },
    // London
    '101750367': {
        headerImageUrl: YGP_HEADER_LDN,
    },
};
const GENERIC_HEADER = {
    headerImageUrl: YGP_HEADER_GENERIC,
};
export const BROWSE_HEADER_TLD_OVERRIDES: {
    [tld in typeof ENGLISH_TLDs[number]]: Partial<BrandState>;
} = {
    [TLD_CANADA]: GENERIC_HEADER,
    [TLD_NEW_ZEALAND]: GENERIC_HEADER,
    [TLD_AUSTRALIA]: GENERIC_HEADER,
    [TLD_UNITED_KINGDOM]: GENERIC_HEADER,
    [TLD_IRELAND]: GENERIC_HEADER,
    [TLD_UNITED_STATES]: GENERIC_HEADER,
};
